import jwtDecode from "jwt-decode";
import { useEffect } from "react";
import { RefreshToken } from "./constants/tokenRefresh";
import { encryptStorage } from "./constants/EncryptStorage";

const REFRESH_THRESHOLD_MS = 30 * 1000;

const UpdateToken = ({ setDoLogout }) => {
  useEffect(() => {
    let isMounted = true;

    const checkTokenTime = async () => {
      const tokenString = encryptStorage.getItem("token");

      if (!tokenString) {
        if (isMounted) setDoLogout(true);
        return;
      }

      try {
        const token = jwtDecode(tokenString);
        const expiresIn = token.exp * 1000 - Date.now();

        if (expiresIn <= REFRESH_THRESHOLD_MS) {
          await RefreshToken();
        }
      } catch (error) {
        console.error("Unable to refresh the authentication token.", error);
        if (isMounted) setDoLogout(true);
      }
    };

    checkTokenTime();
    const interval = setInterval(checkTokenTime, 10000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [setDoLogout]);

  return null;
};

export default UpdateToken;